import { ComponentBase } from "../core/ComponentBase.js";

export class SkillManagerCrud extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
        this.skillConfigRoute = this.config.skillConfigRoute || '/admin/skill-config';
    }

    async initialize() {
        await this.initializeDataCrud();
        await super.initialize();
    }

    async initializeDataCrud() {
        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            instanceId: `${this.config.instanceId}-crud`,
            rpcClass: "SkillRpc",
            schemaPath: "collections/skills",
            rpcMethod: "listSkills", // Custom list method
            idField: "_id",
            title: "Skill Management",
            viewConfig: {
                mode: 'grid',
                disableDefaultCreate: true,
                disableDefaultEdit:   true,
                disableDefaultView:   true,
                disableEdit:          true,
                fields: [
                    {
                        name: 'name',
                        label: 'Skill Name',
                        render: (val, item) => {
                            let badges = '';
                            if (item.isGlobal) badges += '<span class="badge bg-primary ms-2">Global</span>';
                            if (item._source === 'file') badges += '<span class="badge bg-secondary ms-1">System</span>';
                            if (item._source === 'extension') badges += '<span class="badge bg-info-subtle text-info ms-1">Extension</span>';
                            return `<strong>${val}</strong> ${badges}`;
                        }
                    },
                    { name: 'description', label: 'Description' },
                    { name: 'engineType', label: 'Engine' },
                ],
                actions: [
                    {
                        label: 'Configure',
                        icon: 'bi-gear-fill',
                        eventName: 'configureSkill',
                        visibleWhen: (item) => item._source !== 'extension'
                    },
                    {
                        label: 'Clone',
                        icon: 'bi-copy',
                        eventName: 'cloneExtensionSkill',
                        visibleWhen: (item) => item._source === 'extension' && item.cloneAllowed === true
                    },
                    {
                        label: 'Delete',
                        icon: 'bi-trash',
                        eventName: 'deleteItem',
                        className: 'btn-outline-danger',
                        visibleWhen: (item) => item._source !== 'file' && item._source !== 'extension'
                    }
                ],
                toolbar: { create: { enabled: true, label: "Create Skill" } }
            },
            dataConfig: { autoLoad: false }
        });

        this.dataCrud.dataView.on(`configureSkill`, (item) => {
            // If it's a file-based skill, we pass the name instead of _id since it might not have a mongo _id
            const identifier = item._id || item.name;
            this.appClient.layoutEngine.navigate(`${this.skillConfigRoute}?skillId=${identifier}`);
        });

        this.dataCrud.dataView.on(`createItem`, () => {
            this.appClient.layoutEngine.navigate(`${this.skillConfigRoute}`);
        });

        this.dataCrud.dataView.on('cloneExtensionSkill', async (item) => {
            const name = window.prompt('Clone skill as', `${item.name} Copy`);
            if (!name) return;
            try {
                await this.appClient.rpcClient.call('ExtensionInstallRpc.cloneContribution', {
                    contributionRef: item.contributionRef,
                    overrides: { name }
                });
                this.appClient.notifier.success('Skill cloned.');
                await this.dataCrud.refreshData();
            } catch (error) {
                this.appClient.notifier.error(error.message || 'Failed to clone skill.');
            }
        });
    }

    async initAfterLogin() {
        await this.dataCrud.refreshData();
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
        }
        this.container.innerHTML = '';
        if (this.dataCrud) {
            this.container.appendChild(await this.dataCrud.render());
        }
        return this.container;
    }
}
